import AdblockDetector from 'adblock-detector';
import {ADS_TYPE} from "../../Common/Ads/AdsType";

export enum REWARDED_ADS_TYPE {
    COMMON,
    WIN_MULTIPLIER_X2,
    CATALOG_PICTURE,
    SHOP_NEEDLES,
    SHOP_WOOL,
    SHOP_BUCKET,
    SHOP_COMBO
}

export abstract class BaseAdsLogic {
    public skipNextInterstitial: boolean = false;

    protected rewardADBlockedToMsMap: Map<REWARDED_ADS_TYPE, number> = new Map<REWARDED_ADS_TYPE, number>();
    protected rewardADTimeoutSec: number = 3 * 60;
    protected isGameplayRunning: boolean = false;
    protected isSDKReady: boolean = false;

    public isAvailableRewardedAd(type: REWARDED_ADS_TYPE): boolean {
        return this.rewardADBlockedToMsMap.has(type) ? Date.now() > this.rewardADBlockedToMsMap.get(type) : true;
    }

    public timeoutBeforeRewardedAd(type: REWARDED_ADS_TYPE): number {
        return this.rewardADBlockedToMsMap.has(type) ? this.rewardADBlockedToMsMap.get(type) - Date.now() : 0;
    }

    public restartRewardedAdTimeout(type: REWARDED_ADS_TYPE): void {
        this.rewardADBlockedToMsMap.set(type, Date.now() + this.rewardADTimeoutSec * 1000);
    }

    public resetRewardedAdTimeout(type: REWARDED_ADS_TYPE): void {
        this.rewardADBlockedToMsMap.set(type, 0);
    }

    public get isReady(): boolean {
        return this.isSDKReady;
    }

    public gameplayStart(): void {
        if (!this.isGameplayRunning) {
            this.onGameplayStart();
            this.isGameplayRunning = true;
        }
    }

    public gameplayStop(): void {
        if (this.isGameplayRunning) {
            this.onGameplayStop();
            this.isGameplayRunning = false;
        }
    }

    public gameplayRunning(): boolean {
        return this.isGameplayRunning;
    }

    public hasAdBlock(): boolean {
        return false;// AdblockDetector.detect();
    }

    public clearAllBanners(): void {
        this.onClearAllBanners();
    }

    public async requestAd(type: ADS_TYPE = ADS_TYPE.REWARDED): Promise<void> {
        if (type === ADS_TYPE.INTERSTITIAL && this.skipNextInterstitial) {
            this.skipNextInterstitial = false;
            throw new Error('[ADS] Skipped Interstitial');
        }

        return this.onRequestAd(type).catch(err => {
            console.error(err);
            throw err;
        })
    }

    protected onGameplayStart(): void {}
    protected onGameplayStop(): void {}
    protected onClearAllBanners(): void {}
    protected onRequestAd(type: ADS_TYPE): Promise<void> {
        throw new Error('No implementation');
    }
}
